import { legacy_createStore as createStore, combineReducers, applyMiddleware } from 'redux';
import { thunk as thunkMiddleware } from 'redux-thunk';

export const initializeSession = () => ({ type: 'INITIALIZE_SESSION' });

export const storeData = data => ({
  type: 'STORE_DATA',
  data
});

export const storeUser = data => ({
  type: 'STORE_USER',
  data
});

export const setLanguage = language => ({
  type: 'SET_LANGUAGE',
  language
});

export const setTimeZone = timeZone => ({
  type: 'SET_TIMEZONE',
  timeZone
});

export const storeCategories = data => ({
  type: 'STORE_CATEGORIES',
  data
});

export const storeSchemes = data => ({
  type: 'STORE_SCHEMES',
  data
});

export const storeCurrencies = data => ({
  type: 'STORE_CURRENCIES',
  data
});

export const storeSystemTypes = data => ({
  type: 'STORE_SYSTEM_TYPES',
  data
});

const sessionReducer = (state = false, action) => {
  switch (action.type) {
    case 'INITIALIZE_SESSION':
      return true;
    default:
      return state;
  }
};

const dataReducer = (state = [], action) => {
  switch (action.type) {
    case 'STORE_DATA':
      return action.data;
    default:
      return state;
  }
};

const userReducer = (state = null, action) => {
  switch (action.type) {
    case 'STORE_USER':
      return action.data;
    default:
      return state;
  }
};

const languageReducer = (state = null, action) => {
  switch (action.type) {
    case 'SET_LANGUAGE':
      return action.language;
    default:
      return state;
  }
};

const timezoneReducer = (state = null, action) => {
  switch (action.type) {
    case 'SET_TIMEZONE':
      return action.timeZone;
    default:
      return state;
  }
};

const categoriesReducer = (state = null, action) => {
  switch (action.type) {
    case 'STORE_CATEGORIES':
      return action.data;
    default:
      return state;
  }
};

const schemesReducer = (state = null, action) => {
  switch (action.type) {
    case 'STORE_SCHEMES':
      return action.data;
    default:
      return state;
  }
};

const currenciesReducer = (state = null, action) => {
  switch (action.type) {
    case 'STORE_CURRENCIES':
      return action.data;
    default:
      return state;
  }
};

const systemTypesReducer = (state = null, action) => {
  switch (action.type) {
    case 'STORE_SYSTEM_TYPES':
      return action.data;
    default:
      return state;
  }
};

const reducer = combineReducers({
  loggedIn: sessionReducer,
  data: dataReducer,
  user: userReducer,
  categories: categoriesReducer,
  language: languageReducer,
  timeZone: timezoneReducer,
  currencies: currenciesReducer,
  schemes: schemesReducer,
  systemTypes: systemTypesReducer
});

export default initialState =>
  createStore(reducer, initialState, applyMiddleware(thunkMiddleware));